import { render, staticRenderFns } from "./TrackingNotifications.vue?vue&type=template&id=55e0767d"
import script from "./TrackingNotifications.vue?vue&type=script&lang=js"
export * from "./TrackingNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports